import _ from 'lodash';
import isEmail from 'validator/lib/isEmail';

const validatePhone = (number) => {
	const allowedLengths = [10, 13];
	const normalizedNumber = number.replace(/\s+|\(|\)|-|/g, '').replace(/\+/g, '00');
	const isNumber = /^\d+$/.test(normalizedNumber);
	return isNumber && allowedLengths.indexOf(normalizedNumber.length) !== -1;
};

export const validatePassword = ({ password = '', minLength = 8 }) => {
	const errors = {
		minLength: password.length >= minLength,
		minCapital: /[A-Z]/.test(password),
		minLowercase: /[a-z]/.test(password),
	};
	return {
		valid: _.values(errors).every((valid) => !!valid),
		errors,
	};
};

export const validate = {
	email: (email) => !!email && isEmail(email),
	phone: (phoneNumber) => !!phoneNumber && validatePhone(phoneNumber),
	name: (name) => !!name && name.length < 50,
	description: (description) => !!description && description.length > 10,
	reason: (reason) => !_.isEmpty(reason),
	specification: (specification) => !_.isEmpty(specification),
	category: (category) => !_.isEmpty(category),
	device: (device) => !_.isEmpty(device),
};

/**
 * Redux form is not handling rejected values properly
 * This is a hacky fix for that
 * see: https://github.com/redux-form/redux-form/issues/4026
 */
export const catchReduxFormSubmitRejection = (handleSubmit) => (e) => {
	const submitPromise = handleSubmit(e);

	if (submitPromise && submitPromise.catch) {
		submitPromise.catch(() => null);
	}
};
